import router,{ asyncRoutes, constantRoutes } from '@/router'
import auth from '@/plugins/auth'
import { getRouters } from '@/api/login'// 获取路由接口
import Layout from '@/layout/index'
/**
 * 是否有权限
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {

  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
	//  
    const tmp = { ...route }
  
	if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],//路由数组
  addRoutes: [],
  defaultRoutes: [], //默认的路由
  topbarRouters: [], //topbar
  sidebarRouters: [] //侧边栏路由
}

const mutations = {
	// 设置路由
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },

  SET_DEFAULT_ROUTES: (state, routes) => {
    state.defaultRoutes = constantRoutes.concat(routes)
  },

  SET_TOPBAR_ROUTES: (state, routes) => {
    state.topbarRouters = routes
  },

  SET_SIDEBAR_ROUTERS: (state, routes) => {
    state.sidebarRouters = routes
  },
}

const actions = {

	// 生成路由(从后台数据库中请求路由信息，并且)
  GenerateRoutes({ commit }) {
    return new Promise(resolve => {
      // 向后端请求路由数据
      getRouters().then(res => {
        //侧边栏路由数据
        const sdata = JSON.parse(JSON.stringify(res.data))
        //重写的路由数据
        const rdata = JSON.parse(JSON.stringify(res.data))

        // 侧边栏路由
        const sidebarRoutes = filterAsyncRouter(sdata)
        // 后端返回的路由，（不包含目录，只包含children）
        const rewriteRoutes = filterAsyncRouter(rdata, false, true)
        // 过滤的动态路由，asyncRoutes 在 前端路由已经写好，根据权限过滤
        const tempAsyncRoutes = filterDynamicRoutes(asyncRoutes);
        // 增加有权限的动态路由
        router.addRoutes(tempAsyncRoutes);
        commit('SET_ROUTES', rewriteRoutes) //把后端请求过来的写入Router
        commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(sidebarRoutes))
        //以下存储暂时没有使用
        commit('SET_DEFAULT_ROUTES', sidebarRoutes)
        commit('SET_TOPBAR_ROUTES', sidebarRoutes)
        resolve(rewriteRoutes)
      })
    })
  }
}
// 遍历后台传来的路由字符串，转换为组件对象
/**
 * 
 * @param {*} asyncRouterMap 路由menu数据，后台返回的数据
 * @param {*} lastRouter ，父路由?
 * @param {*} type ，type 为true 时，处理children
 * @returns 
 */
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  //进行过滤，返回新的数据
  return asyncRouterMap.filter(route => {
    if (type && route.children) {
      route.children = filterChildren(route.children)
    }

    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout
      } else if (route.component === 'ParentView') {
        route.component = ParentView
      } else if (route.component === 'InnerLink') {
        route.component = InnerLink
      } else {
        //为显示的页面
        route.component = loadView(route.component)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
    } else {
      delete route['children']
      delete route['redirect']
    }
    return true
  })
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
  const res = []
  routes.forEach(route => {
    //遍历路由
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route)
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route)
      }
    }
  })
  return res
}

/**
 * 过滤Children
 */
function filterChildren(childrenMap, lastRouter = false) {
  var children = []
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView' && !lastRouter) {
        el.children.forEach(c => {
          c.path = el.path + '/' + c.path
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c))
            return
          }
          children.push(c)
        })
        return
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
    }
    children = children.concat(el)
  })
  return children
}

/**
 * 加载view
 */
export const loadView = (view) => {
  if (process.env.NODE_ENV === 'development') {
    return (resolve) => require([`@/views/${view}`], resolve)
  } else {
    // 使用 import 实现生产环境的路由懒加载
    return () => import(`@/views/${view}`)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
